import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { DomainID } from '~src/settings/dataconnect-settings/sections/types/Domain';
import { PoolID, SystemDefinedPoolID } from '~src/settings/dataconnect-settings/sections/types/PoolID';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { BaasEdgePoolError } from '../../sections/types/BaasEdgePoolError';

export enum DomainUpdateType {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export interface IUpdateBaasEdgePoolParams {
  poolId: PoolID | SystemDefinedPoolID.Unassigned | SystemDefinedPoolID.Default | SystemDefinedPoolID.Blocked;
  displayName?: string;
  domainChange?: { change: DomainUpdateType.Add | DomainUpdateType.Remove, domainId: DomainID };
  DataConnectSettingsVersion: string;
}

export interface IUpdateBaasEdgePoolResult extends IResult {
  success?: {
    poolId: PoolID | SystemDefinedPoolID.Unassigned | SystemDefinedPoolID.Default | SystemDefinedPoolID.Blocked;
    displayName?: string;
    domainId?: DomainID;
  };
  error?: BaasEdgePoolError;
  DataConnectSettingsVersion: string;
}

export class UpdateBaasEdgePoolRequest extends Request<IUpdateBaasEdgePoolParams, IUpdateBaasEdgePoolResult> {
  constructor(params: IUpdateBaasEdgePoolParams) {
    super('updateBaasEdgePool', params);
  }
}
